import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";

const PersonDetails = () => {
  const { name } = useParams(); // Get the name from the URL
  const [personDetails, setPersonDetails] = useState(null);

  useEffect(() => {
    // Assuming you have a way to fetch person data by name
    fetch(`/api/person/${name}`) // Replace with actual endpoint to fetch details
      .then((response) => response.json())
      .then((data) => setPersonDetails(data))
      .catch((error) => console.error("Error fetching person details:", error));
  }, [name]);

  if (!personDetails) return <div>Loading...</div>;

  return (
    <div>
      <h2>Details for {personDetails.name}</h2>
      <p>City: {personDetails.city}</p>
      <p>Coordinator: {personDetails.coordinatorName}</p>

      {/* Add more fields as necessary */}
    </div>
  );
};

export default PersonDetails;
